/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import EnvironmentService from 'cio/services/environment';

interface AttributeTypeLabelDropdownItemArgs {
  item: Record<string, any> | string;
  labelProperty: string;
  isObject?: boolean;
  hideAttributeLabel?: boolean;
}

export default class AttributeTypeLabelDropdownItem extends Component<AttributeTypeLabelDropdownItemArgs> {
  @service environment!: EnvironmentService;

  get itemLabel() {
    if (typeof this.args.item === 'string') {
      return this.args.item;
    }

    return this.args.item[this.args.labelProperty];
  }
}
